import { connect } from 'react-redux'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import { bindActionCreators } from 'redux'

import { actionCreators } from '@/checkout-instore-legacy/order/actions'
import { verifyIfHasAValidItem } from '@/checkout-instore-legacy/summary/utils'
import SummaryView from '@/checkout-instore-legacy/components/Commons/Summary/SummaryView'

const mapStateToProps = (state) => {
  return {
    hasAtLeastOneValidItem: verifyIfHasAValidItem(state.order.orderForm),
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(actionCreators, dispatch)

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SummaryView)
)
